// Accounting Curriculum Data - Vanuatu National Syllabus
// Years 11-13 Senior Secondary

export const accountingCurriculum = {
  year11: {
    title: "Year 11 Accounting",
    description: "Foundation accounting principles for sole proprietorship businesses",
    hours: 132,
    strands: [
      {
        id: "11ACC1",
        name: "Communicating Financial and Non-Financial Information",
        icon: "MessageSquare",
        color: "blue",
        hours: 13,
        weight: 10,
        outcome: "Describe the role of accounting in society at an individual, group and organizational level",
        subStrands: [
          {
            id: "11ACC1.1",
            name: "Conceptual Basis of Accounting",
            outcome: "Demonstrate an understanding of the nature and functions of accounting and the basic principles/concepts on which accounting is based",
            topics: [
              { code: "11ACC1.1.1.1", topic: "Define accounting and the financial elements that make up the basic accounting equation", level: 1 },
              { code: "11ACC1.1.1.2", topic: "State the basic accounting equation", level: 1 },
              { code: "11ACC1.1.1.3", topic: "Identify the financial elements that make up the basic and expanded accounting equations", level: 1 },
              { code: "11ACC1.1.1.4", topic: "Define the five financial elements (Assets, Liabilities, Owner's Equity, Revenue, Expenses)", level: 1 },
              { code: "11ACC1.1.1.5", topic: "Identify types of business organizations", level: 1 },
              { code: "11ACC1.1.1.6", topic: "List the accounting principles/assumptions and qualitative characteristics", level: 1 },
              { code: "11ACC1.1.2.1", topic: "Describe the role of accounting", level: 2 },
              { code: "11ACC1.1.2.2", topic: "Describe the nature of each type of business organization", level: 2 },
              { code: "11ACC1.1.2.3", topic: "Describe the principles and qualitative characteristics of accounting information", level: 2 },
              { code: "11ACC1.1.3.1", topic: "Explain the accounting entity concept", level: 3 },
              { code: "11ACC1.1.3.2", topic: "Explain the effects of transactions on the basic accounting equation", level: 3 },
              { code: "11ACC1.1.3.3", topic: "Contrast the pros and cons of each type of business organization", level: 3 }
            ]
          },
          {
            id: "11ACC1.2",
            name: "Internal Control",
            outcome: "Demonstrate an understanding of the internal control principles and procedures for cash receipts and cash payments",
            topics: [
              { code: "11ACC1.2.1.1", topic: "Identify the internal control principles", level: 1 },
              { code: "11ACC1.2.2.1", topic: "List internal control procedures for cash receipts and cash payments", level: 2 },
              { code: "11ACC1.2.3.1", topic: "Explain the need for internal control over cash", level: 3 },
              { code: "11ACC1.2.3.2", topic: "Relate each internal control procedure over cash to a principle of internal control", level: 3 },
              { code: "11ACC1.2.4.1", topic: "Discuss alternative ways of improving firm's internal control procedures", level: 4 }
            ]
          }
        ]
      },
      {
        id: "11ACC2",
        name: "Recording Financial and Non-Financial Information",
        icon: "FileText",
        color: "green",
        hours: 66,
        weight: 50,
        outcome: "Record financial transactions in accordance with generally accepted accounting principles and practice",
        subStrands: [
          {
            id: "11ACC2.1",
            name: "Processing Financial Data",
            outcome: "Demonstrate an understanding of financial transactions for a sole proprietorship business",
            topics: [
              { code: "11ACC2.1.1.1", topic: "Name the different stages in the accounting cycle", level: 1 },
              { code: "11ACC2.1.1.2", topic: "Identify accounts affected by each transaction", level: 1 },
              { code: "11ACC2.1.1.3", topic: "Identify source documents", level: 1 },
              { code: "11ACC2.1.1.4", topic: "Extract a trial balance from the general ledger", level: 1 },
              { code: "11ACC2.1.2.1", topic: "Prepare ledger accounts in t-form and columnar form", level: 2 },
              { code: "11ACC2.1.2.2", topic: "Describe transactions captured in different source documents", level: 2 },
              { code: "11ACC2.1.2.3", topic: "Describe what a double entry is", level: 2 },
              { code: "11ACC2.1.2.4", topic: "Describe the purpose of each of the seven journals", level: 2 },
              { code: "11ACC2.1.3.1", topic: "Classify and record transactions in appropriate journals", level: 3 },
              { code: "11ACC2.1.3.2", topic: "Interpret source documents", level: 3 },
              { code: "11ACC2.1.3.3", topic: "Design journals and ledger accounts", level: 3 },
              { code: "11ACC2.1.3.4", topic: "Design appropriate source documents for given transactions", level: 3 },
              { code: "11ACC2.1.3.5", topic: "Analyse and post transactions in the journals and the general ledger", level: 3 },
              { code: "11ACC2.1.3.6", topic: "Apply double entry rule when posting transactions to the ledger", level: 3 },
              { code: "11ACC2.1.3.7", topic: "Prepare chart of accounts", level: 3 }
            ]
          },
          {
            id: "11ACC2.2",
            name: "Accounting System",
            outcome: "Demonstrate an understanding of subsidiary records and control accounts for debtors and creditors",
            topics: [
              { code: "11ACC2.2.2.1", topic: "Complete a petty cash book", level: 2 },
              { code: "11ACC2.2.2.2", topic: "Interpret a bank statement", level: 2 },
              { code: "11ACC2.2.3.1", topic: "Prepare a bank reconciliation statement", level: 3 },
              { code: "11ACC2.2.3.2", topic: "Implement a petty cash imprest system", level: 3 },
              { code: "11ACC2.2.4.1", topic: "Discuss the need for reconciling cash records", level: 4 }
            ]
          }
        ]
      },
      {
        id: "11ACC3",
        name: "Reporting of Financial and Non-Financial Information",
        icon: "BarChart2",
        color: "purple",
        hours: 40,
        weight: 30,
        outcome: "Report financial transactions in accordance with generally accepted accounting principles and practice",
        subStrands: [
          {
            id: "11ACC3.1",
            name: "Final Accounts and Reports",
            outcome: "Demonstrate an understanding of final accounts for a sole proprietor and a not-for-profit organization",
            topics: [
              { code: "11ACC3.1.1.1", topic: "Identify balance day adjustment accounts", level: 1 },
              { code: "11ACC3.1.1.2", topic: "Identify types of accounts to be closed off", level: 1 },
              { code: "11ACC3.1.1.3", topic: "Identify accounts affected by closing entries", level: 1 },
              { code: "11ACC3.1.2.1", topic: "Account for balance day adjustments for a sole proprietor and a not-for-profit organisation", level: 2 },
              { code: "11ACC3.1.2.2", topic: "Account for subscriptions in advance and in arrears", level: 2 },
              { code: "11ACC3.1.2.3", topic: "Account for closing entries for a sole proprietor and a not-for-profit organisation", level: 2 },
              { code: "11ACC3.1.2.4", topic: "Complete a 10 column worksheet", level: 2 },
              { code: "11ACC3.1.3.1", topic: "Discuss the need for balance day adjustments", level: 3 },
              { code: "11ACC3.1.3.2", topic: "Explain the need for closing entries", level: 3 }
            ]
          },
          {
            id: "11ACC3.2",
            name: "Profit Determining/Sharing Reports",
            outcome: "Demonstrate an understanding of profit determining accounts for a profit making business and a not-for-profit organization",
            topics: [
              { code: "11ACC3.2.1.1", topic: "Define gross profit, net profit, net surplus, net deficit", level: 1 },
              { code: "11ACC3.2.1.2", topic: "Calculate Gross Profit and Net Profit in the appropriate accounts", level: 2 },
              { code: "11ACC3.2.1.3", topic: "Calculate net surplus or net deficit for a non-profit organisation", level: 2 },
              { code: "11ACC3.2.2.1", topic: "Complete the trading account", level: 2 },
              { code: "11ACC3.2.2.2", topic: "Complete the profit & loss account, incorporating balance day adjustments", level: 2 },
              { code: "11ACC3.2.2.3", topic: "Complete a refreshment trading account for non-profit organisation", level: 2 },
              { code: "11ACC3.2.2.4", topic: "Complete the capital account for a sole proprietorship", level: 2 },
              { code: "11ACC3.2.2.5", topic: "Account for reversing entries", level: 2 }
            ]
          },
          {
            id: "11ACC3.3",
            name: "Financial Statements",
            outcome: "Demonstrate an understanding of financial statements for a trading business and a not-for-profit organisation",
            topics: [
              { code: "11ACC3.3.1.1", topic: "Define the statement of financial performance", level: 1 },
              { code: "11ACC3.3.1.2", topic: "Define the statement of financial position", level: 1 },
              { code: "11ACC3.3.1.3", topic: "Define current and non-current assets", level: 1 },
              { code: "11ACC3.3.2.1", topic: "Classify operating expenses into Selling & Distribution, General and Administrative, and Financial Expenses", level: 2 },
              { code: "11ACC3.3.2.2", topic: "Classify assets into Current and Non-Current Assets", level: 2 },
              { code: "11ACC3.3.2.3", topic: "Classify liabilities into Current and Non-Current Liabilities", level: 2 },
              { code: "11ACC3.3.3.1", topic: "Prepare a fully classified statement of financial position", level: 3 },
              { code: "11ACC3.3.3.2", topic: "Prepare a statement of receipts and payments for not-for-profit organization", level: 3 },
              { code: "11ACC3.3.4.1", topic: "Prepare a fully classified statement of financial performance, incorporating balance day adjustments", level: 4 },
              { code: "11ACC3.3.4.2", topic: "Prepare a fully classified statement of financial position, incorporating balance day adjustments", level: 4 }
            ]
          }
        ]
      },
      {
        id: "11ACC4",
        name: "Evaluating Financial and Non-Financial Information",
        icon: "TrendingUp",
        color: "orange",
        hours: 13,
        weight: 10,
        outcome: "Analyse, interpret and evaluate financial statements to enable informed decisions",
        subStrands: [
          {
            id: "11ACC4.1",
            name: "Analysis and Interpretation of Financial Statements",
            outcome: "Demonstrate an understanding of accounting ratios and percentages for sole traders",
            topics: [
              { code: "11ACC4.1.1.1", topic: "Name the three areas of business performance (Profitability, Financial Stability, Management Effectiveness)", level: 1 },
              { code: "11ACC4.1.1.2", topic: "Define profitability, financial stability and management effectiveness", level: 1 },
              { code: "11ACC4.1.1.3", topic: "State the relevant formulae used to calculate ratios and percentages", level: 1 },
              { code: "11ACC4.1.2.1", topic: "Calculate common ratios and percentages (profitability and financial stability)", level: 2 },
              { code: "11ACC4.1.3.1", topic: "Explain the reasons for analysing financial reports", level: 3 },
              { code: "11ACC4.1.3.2", topic: "Interpret each ratio or percentage", level: 3 }
            ]
          },
          {
            id: "11ACC4.2",
            name: "Decision-making",
            outcome: "Demonstrate an understanding of different types of decisions",
            topics: [
              { code: "11ACC4.2.2.1", topic: "Arrange the stages of decision making in their correct order", level: 2 },
              { code: "11ACC4.2.2.2", topic: "Describe the different stages of decision making", level: 2 },
              { code: "11ACC4.2.3.1", topic: "Explain the decision making process flow chart", level: 3 },
              { code: "11ACC4.2.3.2", topic: "Explain the need for quality decision-making", level: 3 },
              { code: "11ACC4.2.4.1", topic: "Discuss methods of gathering information to assist decision-making", level: 4 }
            ]
          }
        ]
      }
    ]
  },
  year12: {
    title: "Year 12 Accounting",
    description: "Intermediate accounting for trading and service enterprises",
    hours: 165,
    strands: [
      {
        id: "12ACC1",
        name: "Communicating Financial and Non-Financial Information",
        icon: "MessageSquare",
        color: "blue",
        hours: 23,
        weight: 14,
        outcome: "Describe the role of accounting in society at an individual, group and organizational level",
        subStrands: [
          {
            id: "12ACC1.1",
            name: "Conceptual Basis of Accounting",
            outcome: "Demonstrate an understanding of the nature and functions of accounting and the basic principles/concepts on which accounting is based",
            topics: [
              { code: "12ACC1.1.1.1", topic: "Define accounting", level: 1 },
              { code: "12ACC1.1.1.2", topic: "Define the concepts and qualitative characteristics of accounting information", level: 1 },
              { code: "12ACC1.1.1.3", topic: "Identify the users of accounting information", level: 1 },
              { code: "12ACC1.1.1.4", topic: "Define the financial elements (A, L, OE, E, R)", level: 1 },
              { code: "12ACC1.1.1.5", topic: "Identify sources and uses of funds", level: 1 },
              { code: "12ACC1.1.2.1", topic: "Describe the functions of accounting", level: 2 },
              { code: "12ACC1.1.2.2", topic: "Describe the role of accounting", level: 2 },
              { code: "12ACC1.1.3.1", topic: "Explain the relationship between owner's equity, liabilities and assets", level: 3 },
              { code: "12ACC1.1.3.2", topic: "Apply the concepts and qualitative characteristics to the financial statements", level: 3 },
              { code: "12ACC1.1.3.3", topic: "Differentiate between capital and revenue expenditure", level: 3 }
            ]
          },
          {
            id: "12ACC1.2",
            name: "Internal Control",
            outcome: "Demonstrate an understanding of the principles and procedures of internal control to given situations",
            topics: [
              { code: "12ACC1.2.1.1", topic: "Define internal control", level: 1 },
              { code: "12ACC1.2.1.2", topic: "State a principle of internal control", level: 1 },
              { code: "12ACC1.2.1.3", topic: "Identify strengths and weaknesses of an internal control system", level: 1 },
              { code: "12ACC1.2.2.1", topic: "List the objectives of internal control", level: 2 },
              { code: "12ACC1.2.2.2", topic: "List the principles of internal control", level: 2 },
              { code: "12ACC1.2.2.3", topic: "List internal control procedures for inventories, accounts receivable and fixed assets", level: 2 },
              { code: "12ACC1.2.3.1", topic: "Explain the need for internal control over inventories, accounts receivable and fixed assets", level: 3 },
              { code: "12ACC1.2.4.1", topic: "Suggest alternative ways of improving a firm's internal control procedures", level: 4 },
              { code: "12ACC1.2.4.2", topic: "Critically examine a firm's internal control procedures", level: 4 }
            ]
          }
        ]
      },
      {
        id: "12ACC2",
        name: "Recording Financial and Non-Financial Information",
        icon: "FileText",
        color: "green",
        hours: 70,
        weight: 42,
        outcome: "Record financial transactions in accordance with generally accepted accounting principles and practice",
        subStrands: [
          {
            id: "12ACC2.1",
            name: "Processing Financial Data",
            outcome: "Demonstrate an understanding of processing financial data for a trading and a service enterprise",
            topics: [
              { code: "12ACC2.1.1.1", topic: "Identify source documents used for recording transactions", level: 1 },
              { code: "12ACC2.1.2.1", topic: "Record transactions on source documents", level: 2 },
              { code: "12ACC2.1.2.2", topic: "Describe the input, process and output components of an accounting cycle", level: 2 },
              { code: "12ACC2.1.3.1", topic: "Analyse transactions in terms of their effects on the accounting equation", level: 3 },
              { code: "12ACC2.1.3.2", topic: "Prepare a chart of accounts for an entity", level: 3 },
              { code: "12ACC2.1.3.3", topic: "Use a chart of accounts for an entity", level: 3 },
              { code: "12ACC2.1.3.4", topic: "Prepare accounting records (journals, ledger and trial balance)", level: 3 },
              { code: "12ACC2.1.3.5", topic: "Compare manual and computer processing methods", level: 3 },
              { code: "12ACC2.1.3.6", topic: "Analyse transactions to determine journals and accounts affected", level: 3 },
              { code: "12ACC2.1.3.7", topic: "Explain and apply the debit and credit rules (Double Entry)", level: 3 }
            ]
          },
          {
            id: "12ACC2.2",
            name: "Accounting System",
            outcome: "Demonstrate an understanding of accounting systems and subsidiary records for inventories, accounts receivable, accounts payable and fixed assets subsystems",
            topics: [
              { code: "12ACC2.2.2.1", topic: "Calculate cost of sales under perpetual inventory system", level: 2 },
              { code: "12ACC2.2.2.2", topic: "Calculate depreciation using Straight Line, Reducing Balance, Units of use, Sum of Digits methods", level: 2 },
              { code: "12ACC2.2.2.3", topic: "Complete stock ledger cards", level: 2 },
              { code: "12ACC2.2.2.4", topic: "Complete subsidiary ledgers control accounts and schedules for debtors and creditors", level: 2 },
              { code: "12ACC2.2.2.5", topic: "Describe the process of verifying debtors and creditors records", level: 2 },
              { code: "12ACC2.2.2.6", topic: "Account for depreciation of fixed assets", level: 2 },
              { code: "12ACC2.2.2.7", topic: "Account for disposal of fixed assets", level: 2 },
              { code: "12ACC2.2.3.1", topic: "Prepare a fixed asset register", level: 3 },
              { code: "12ACC2.2.3.2", topic: "Account for inventories under periodic and perpetual systems", level: 3 },
              { code: "12ACC2.2.3.3", topic: "Discuss debtors and creditors subsidiary records as a control mechanism", level: 3 },
              { code: "12ACC2.2.3.4", topic: "Differentiate between the periodic and perpetual inventory systems", level: 3 },
              { code: "12ACC2.2.3.5", topic: "Explain the purpose of depreciating fixed assets", level: 3 }
            ]
          }
        ]
      },
      {
        id: "12ACC3",
        name: "Reporting of Financial and Non-Financial Information",
        icon: "BarChart2",
        color: "purple",
        hours: 46,
        weight: 28,
        outcome: "Report financial transactions in accordance with generally accepted accounting principles and practice",
        subStrands: [
          {
            id: "12ACC3.1",
            name: "Final Accounts and Reports",
            outcome: "Demonstrate an understanding of balance day adjustments and final accounts for a sole proprietor and a community organization",
            topics: [
              { code: "12ACC3.1.1.1", topic: "Define subscriptions", level: 1 },
              { code: "12ACC3.1.1.2", topic: "Give an example of a subscription", level: 1 },
              { code: "12ACC3.1.2.1", topic: "Describe the process of balance day adjustments", level: 2 },
              { code: "12ACC3.1.2.2", topic: "Complete a 10-column worksheet", level: 2 },
              { code: "12ACC3.1.3.1", topic: "Account for subscriptions in advance and in arrears", level: 3 },
              { code: "12ACC3.1.3.2", topic: "Explain the need for balance day adjustments", level: 3 },
              { code: "12ACC3.1.3.3", topic: "Prepare reversing entries", level: 3 },
              { code: "12ACC3.1.3.4", topic: "Prepare journal and ledger entries for balance day adjustments (accruals, prepayments, bad debts, depreciation)", level: 3 },
              { code: "12ACC3.1.3.5", topic: "Prepare a subscription account", level: 3 }
            ]
          },
          {
            id: "12ACC3.2",
            name: "Profit Determining/Sharing Reports",
            outcome: "Demonstrate an understanding of the profit determining accounts for a sole proprietor and a community organization",
            topics: [
              { code: "12ACC3.2.1.1", topic: "Identify accounts affected by closing entries", level: 1 },
              { code: "12ACC3.2.1.2", topic: "State the purpose for the trading account", level: 1 },
              { code: "12ACC3.2.1.3", topic: "State the purpose for the profit and loss account", level: 1 },
              { code: "12ACC3.2.2.1", topic: "Calculate Gross Profit and Net Profit for a sole proprietor", level: 2 },
              { code: "12ACC3.2.2.2", topic: "Calculate net surplus or net deficit for a non-profit organisation", level: 2 },
              { code: "12ACC3.2.2.3", topic: "Complete the capital account for a sole proprietor", level: 2 },
              { code: "12ACC3.2.3.1", topic: "Prepare the trading account for sole proprietor", level: 3 },
              { code: "12ACC3.2.3.2", topic: "Prepare the profit and loss account, incorporating balance day adjustments", level: 3 },
              { code: "12ACC3.2.3.3", topic: "Prepare supplementary trading and activity accounts for community organisation", level: 3 },
              { code: "12ACC3.2.3.4", topic: "Prepare closing journal entries", level: 3 },
              { code: "12ACC3.2.4.1", topic: "Discuss the need for closing entries using specific examples", level: 4 }
            ]
          },
          {
            id: "12ACC3.3",
            name: "Financial Statements",
            outcome: "Demonstrate an understanding of financial statements for a sole proprietor and a community organisation",
            topics: [
              { code: "12ACC3.3.1.1", topic: "Define the statement of accounting policies", level: 1 },
              { code: "12ACC3.3.1.2", topic: "Define the statement of changes in cash position", level: 1 },
              { code: "12ACC3.3.3.1", topic: "Prepare the statement of financial performance for a sole proprietor", level: 3 },
              { code: "12ACC3.3.3.2", topic: "Prepare the statement of financial performance for a community organisation", level: 3 },
              { code: "12ACC3.3.3.3", topic: "Prepare the statement of financial position for a sole proprietor", level: 3 },
              { code: "12ACC3.3.3.4", topic: "Prepare the statement of financial position for a community organisation", level: 3 },
              { code: "12ACC3.3.3.5", topic: "Prepare the statement of changes in cash position", level: 3 },
              { code: "12ACC3.3.3.6", topic: "Explain the purpose for the statement of financial performance", level: 3 },
              { code: "12ACC3.3.3.7", topic: "Explain the purpose for the statement of financial position", level: 3 },
              { code: "12ACC3.3.3.8", topic: "Explain the purpose for the statement of changes in cash position", level: 3 },
              { code: "12ACC3.3.3.9", topic: "Explain the purpose for the statement of accounting policies", level: 3 }
            ]
          }
        ]
      },
      {
        id: "12ACC4",
        name: "Evaluating Financial and Non-Financial Information",
        icon: "TrendingUp",
        color: "orange",
        hours: 26,
        weight: 16,
        outcome: "Analyse, interpret and evaluate financial statements to enable informed decisions",
        subStrands: [
          {
            id: "12ACC4.1",
            name: "Analysis and Interpretation of Financial Statements",
            outcome: "Demonstrate an understanding of the analysis and interpretation of financial statements for sole proprietors",
            topics: [
              { code: "12ACC4.1.1.1", topic: "Identify the purpose of ratios measuring profitability, financial stability, liquidity and management effectiveness", level: 1 },
              { code: "12ACC4.1.1.2", topic: "Identify ratios and percentages appropriate for the entity", level: 1 },
              { code: "12ACC4.1.1.3", topic: "Identify trends in the ratios and percentages", level: 1 },
              { code: "12ACC4.1.2.1", topic: "Calculate ratios and percentages for profitability, financial stability, liquidity and management effectiveness", level: 2 },
              { code: "12ACC4.1.2.2", topic: "Describe the trends in the ratios and percentages", level: 2 },
              { code: "12ACC4.1.3.1", topic: "Explain the purpose of analysing financial information", level: 3 },
              { code: "12ACC4.1.3.2", topic: "Discuss the ratios and percentages appropriate for the entity", level: 3 },
              { code: "12ACC4.1.3.3", topic: "Analyse/interpret ratios and percentages for at least a three-year period", level: 3 },
              { code: "12ACC4.1.3.4", topic: "Explain possible reasons for the trends in the ratios and percentages", level: 3 },
              { code: "12ACC4.1.3.5", topic: "Interpret the Statement of Changes in Cash Position", level: 3 },
              { code: "12ACC4.1.4.1", topic: "Evaluate the results of the calculations for a specific business over time", level: 4 },
              { code: "12ACC4.1.4.2", topic: "Critically reflect on an entity's performance using comparative figures and industry averages", level: 4 },
              { code: "12ACC4.1.4.3", topic: "Assess the entity's management of its cash resources", level: 4 },
              { code: "12ACC4.1.4.4", topic: "Recommend alternative measures to improve financial performance", level: 4 },
              { code: "12ACC4.1.4.5", topic: "Produce a written report including graphs, tables and recommendations", level: 4 }
            ]
          },
          {
            id: "12ACC4.2",
            name: "Decision-making",
            outcome: "Demonstrate an understanding of the decision making processes and different types of decisions",
            topics: [
              { code: "12ACC4.2.1.1", topic: "Identify the objective of the decision to be made", level: 1 },
              { code: "12ACC4.2.1.2", topic: "Identify financial and non-financial information needed to make decisions", level: 1 },
              { code: "12ACC4.2.1.3", topic: "Identify the types of decisions made by different managers", level: 1 },
              { code: "12ACC4.2.2.1", topic: "List the stages of decision making in their correct order", level: 2 },
              { code: "12ACC4.2.2.2", topic: "Describe the different stages of decision making", level: 2 },
              { code: "12ACC4.2.3.1", topic: "Interpret the decision making flow chart", level: 3 },
              { code: "12ACC4.2.3.2", topic: "Explain the need for quality decision-making", level: 3 },
              { code: "12ACC4.2.3.3", topic: "Differentiate between routine and strategic decisions", level: 3 },
              { code: "12ACC4.2.3.4", topic: "Discuss methods of gathering information to assist decision-making", level: 3 }
            ]
          }
        ]
      }
    ]
  },
  year13: {
    title: "Year 13 Accounting",
    description: "Advanced accounting for partnerships, companies and manufacturing firms",
    hours: 165,
    strands: [
      {
        id: "13ACC1",
        name: "Communicating Financial and Non-Financial Information",
        icon: "MessageSquare",
        color: "blue",
        hours: 33,
        weight: 20,
        outcome: "Describe the role of accounting in society at an individual, group and organizational level",
        subStrands: [
          {
            id: "13ACC1.1",
            name: "Conceptual Basis of Accounting",
            outcome: "Demonstrate an understanding of the nature, scope and functions of accounting and the application of the concepts and assumptions of accounting in context",
            topics: [
              { code: "13ACC1.1.1.1", topic: "Identify the features and legal requirements of partnerships, exempt companies and reporting entities", level: 1 },
              { code: "13ACC1.1.1.2", topic: "Define the financial elements", level: 1 },
              { code: "13ACC1.1.2.1", topic: "Describe the role of the accounting profession, Institute of Chartered Accountants, and Accounting Standards Board", level: 2 },
              { code: "13ACC1.1.2.2", topic: "Describe the purpose, application and scope of the Accounting Framework", level: 2 },
              { code: "13ACC1.1.2.3", topic: "Describe the objectives of General Purpose Financial Reports", level: 2 },
              { code: "13ACC1.1.2.4", topic: "Describe the concepts and qualitative characteristics of accounting information", level: 2 },
              { code: "13ACC1.1.3.1", topic: "Apply the concepts and qualitative characteristics of accounting information in context", level: 3 },
              { code: "13ACC1.1.3.2", topic: "Apply the definitions of the financial elements in context", level: 3 }
            ]
          },
          {
            id: "13ACC1.2",
            name: "Internal Control",
            outcome: "Demonstrate an understanding of the strengths and weaknesses of internal control systems and procedures",
            topics: [
              { code: "13ACC1.2.1.1", topic: "Define internal control and corporate governance", level: 1 },
              { code: "13ACC1.2.2.1", topic: "Describe the objectives and components of internal control", level: 2 },
              { code: "13ACC1.2.3.1", topic: "Apply internal control principles to manufacturing operations", level: 3 },
              { code: "13ACC1.2.4.1", topic: "Evaluate the effectiveness of internal control systems", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13ACC2",
        name: "Recording Financial and Non-Financial Information",
        icon: "FileText",
        color: "green",
        hours: 50,
        weight: 30,
        outcome: "Record financial transactions in accordance with generally accepted accounting principles and practice",
        subStrands: [
          {
            id: "13ACC2.1",
            name: "Processing Financial Data",
            outcome: "Demonstrate an understanding of processing financial transactions for partnerships, companies and manufacturing firms",
            topics: [
              { code: "13ACC2.1.1.1", topic: "Identify partner contributions and profit sharing arrangements", level: 1 },
              { code: "13ACC2.1.2.1", topic: "Record partnership formation, changes and dissolution", level: 2 },
              { code: "13ACC2.1.2.2", topic: "Record share capital transactions (issue, calls, forfeiture)", level: 2 },
              { code: "13ACC2.1.3.1", topic: "Prepare manufacturing cost accounts", level: 3 },
              { code: "13ACC2.1.3.2", topic: "Calculate and record cost of goods manufactured", level: 3 },
              { code: "13ACC2.1.3.3", topic: "Apply job costing and process costing methods", level: 3 }
            ]
          },
          {
            id: "13ACC2.2",
            name: "Accounting System",
            outcome: "Demonstrate an understanding of accounting systems, subsidiary records and control accounts for a manufacturing job costing system",
            topics: [
              { code: "13ACC2.2.2.1", topic: "Record direct materials, direct labour and manufacturing overheads", level: 2 },
              { code: "13ACC2.2.2.2", topic: "Calculate predetermined overhead rates", level: 2 },
              { code: "13ACC2.2.3.1", topic: "Prepare job cost sheets", level: 3 },
              { code: "13ACC2.2.3.2", topic: "Account for over/under-applied overheads", level: 3 },
              { code: "13ACC2.2.4.1", topic: "Evaluate costing systems for decision-making", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13ACC3",
        name: "Reporting of Financial and Non-Financial Information",
        icon: "BarChart2",
        color: "purple",
        hours: 57,
        weight: 34,
        outcome: "Report financial transactions in accordance with generally accepted accounting principles and practice",
        subStrands: [
          {
            id: "13ACC3.1",
            name: "Final Accounts and Reports",
            outcome: "Demonstrate an understanding of balance day adjustments and final accounts for Partnerships, Companies and Manufacturing firms",
            topics: [
              { code: "13ACC3.1.2.1", topic: "Prepare balance day adjustments for partnerships and companies", level: 2 },
              { code: "13ACC3.1.3.1", topic: "Prepare final accounts for partnerships", level: 3 },
              { code: "13ACC3.1.3.2", topic: "Prepare final accounts for companies", level: 3 },
              { code: "13ACC3.1.3.3", topic: "Prepare manufacturing accounts", level: 3 }
            ]
          },
          {
            id: "13ACC3.2",
            name: "Profit Determining/Sharing Reports",
            outcome: "Demonstrate an understanding of profit determining and profit sharing accounts for Partnerships, Companies and Manufacturing firms",
            topics: [
              { code: "13ACC3.2.2.1", topic: "Calculate and distribute partnership profits", level: 2 },
              { code: "13ACC3.2.2.2", topic: "Prepare appropriation accounts for partnerships", level: 2 },
              { code: "13ACC3.2.3.1", topic: "Prepare appropriation accounts for companies", level: 3 },
              { code: "13ACC3.2.3.2", topic: "Account for dividends (interim and final)", level: 3 },
              { code: "13ACC3.2.3.3", topic: "Calculate cost of goods manufactured", level: 3 }
            ]
          },
          {
            id: "13ACC3.3",
            name: "Financial Statements",
            outcome: "Demonstrate an understanding of financial statements for Partnerships, Companies and Manufacturing firms",
            topics: [
              { code: "13ACC3.3.1.1", topic: "Identify the components of company financial statements", level: 1 },
              { code: "13ACC3.3.2.1", topic: "Describe disclosure requirements for companies", level: 2 },
              { code: "13ACC3.3.3.1", topic: "Prepare statement of financial performance for partnerships", level: 3 },
              { code: "13ACC3.3.3.2", topic: "Prepare statement of financial position for partnerships", level: 3 },
              { code: "13ACC3.3.3.3", topic: "Prepare financial statements for companies (reporting entity)", level: 3 },
              { code: "13ACC3.3.3.4", topic: "Prepare statement of cash flows", level: 3 },
              { code: "13ACC3.3.3.5", topic: "Prepare manufacturing statement", level: 3 },
              { code: "13ACC3.3.4.1", topic: "Prepare consolidated financial statements (basic)", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13ACC4",
        name: "Evaluating Financial and Non-Financial Information",
        icon: "TrendingUp",
        color: "orange",
        hours: 25,
        weight: 16,
        outcome: "Analyse, interpret and evaluate financial statements to enable informed decisions",
        subStrands: [
          {
            id: "13ACC4.1",
            name: "Analysis and Interpretation of Financial Statements",
            outcome: "Demonstrate an understanding of the analysis and interpretation of financial performance, position, cash flows and management effectiveness",
            topics: [
              { code: "13ACC4.1.2.1", topic: "Calculate profitability ratios for partnerships and companies", level: 2 },
              { code: "13ACC4.1.2.2", topic: "Calculate gearing and investment ratios", level: 2 },
              { code: "13ACC4.1.3.1", topic: "Analyse cash flow statements", level: 3 },
              { code: "13ACC4.1.3.2", topic: "Compare performance using industry benchmarks", level: 3 },
              { code: "13ACC4.1.4.1", topic: "Evaluate investment decisions using financial analysis", level: 4 },
              { code: "13ACC4.1.4.2", topic: "Prepare comprehensive financial analysis reports", level: 4 }
            ]
          },
          {
            id: "13ACC4.2",
            name: "Decision-making",
            outcome: "Demonstrate an understanding of operational and management decision making for a Partnership, Company and a Manufacturing firm",
            topics: [
              { code: "13ACC4.2.2.1", topic: "Identify relevant costs for decision making", level: 2 },
              { code: "13ACC4.2.3.1", topic: "Apply cost-volume-profit analysis", level: 3 },
              { code: "13ACC4.2.3.2", topic: "Make pricing decisions using costing data", level: 3 },
              { code: "13ACC4.2.4.1", topic: "Evaluate make-or-buy decisions", level: 4 },
              { code: "13ACC4.2.4.2", topic: "Evaluate capital investment decisions", level: 4 }
            ]
          }
        ]
      }
    ]
  }
};

export default accountingCurriculum;
